
// import { parseConcatNumber } from '@/utils/filters';
import { getBoardCategorylistAll } from '@/api/board';
import { insertPost } from '@/api/post';
import { ElForm } from 'element-ui/types/form';
import {
  Component,
  Vue,
  // Prop,
} from 'vue-property-decorator';

@Component({
  name: 'BasicForm',
  components: {
  },
})
export default class extends Vue {
  mounted() {
    this.getBoardCategorylistAll();
  }

  private form = {
    boardUid: '4360c542-4861-4b23-9a29-215336b67976',
    title: '',
    categoryUid: '',
    categoryList: [
      {
        categoryUid: '',
      },
    ],
    content: '',
    privacy: false,
  }

  private categoryList = [];

  private rules = {
    title: [
      { required: true, message: '제목을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    // chargePersion: [
    //   { required: true, message: '담당자를 선택하세요.', trigger: ['change', 'blur'] },
    // ],
    // tel: [
    //   { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
    // ],
    // email: [
    //   { required: false, message: '인원을 입력하세요.', trigger: ['blur', 'change'] },
    // ],
    categoryUid: [
      { required: true, message: '문의분야를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    content: [
      { required: true, message: '문의내용을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  }

  private handleClickSave() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        if (!this.form.privacy) {
          alert('개인정보제공에 동의해주세요.');
        } else {
          this.$confirm('문의 글을 작성하시겠습니까?', '문의하기', {
            confirmButtonText: '저장',
            cancelButtonText: '취소',
            type: 'info',
          }).then(() => {
            this.form.categoryList[0].categoryUid = this.form.categoryUid;
            insertPost(this.form).then(() => {
              this.$router.push({ name: 'one-on-oneInquiry' });
            });
          });
        }
      }
    });
  }

  // 문의분야 카테고리
  private getBoardCategorylistAll() {
    const uid = '74722f96-be2a-4412-9fc0-80eb5fc1040a';
    getBoardCategorylistAll(uid).then((res) => {
      this.categoryList = res.data[0].children;
    });
  }
}
